import resizedImage from 'components/shared/molecules/ResizedImage/ResizedImage';

export default function PreResizedImage(src, width) {
    return new Promise((resolve, reject) => {
        const image = new window.Image();
        image.addEventListener('load', async () => {
            const adjustedWidth = width;
            const adjustedHeight = (image.height / image.width) * width;
            const resizedSavedImage = await resizedImage(src, adjustedWidth, adjustedHeight);
            resolve(resizedSavedImage);
        });
        image.addEventListener('error', (error) => reject(error));
        image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
        image.src = src;
    });
}
